import { Heading } from '@core/ui';
import { EditProfileFormTitleProps } from './types';

export const EditProfileFormTitle = ({ profileTitle }: EditProfileFormTitleProps) => (
    <Heading variant="h2" classNames={`pb-4 md:pb-10`}>
        {profileTitle}
    </Heading>
);
